export default __webpack_public_path__ + "e5293c389d75b6208160b2c6ddb61dd0.svg";